import { render, staticRenderFns } from "./Archivar.vue?vue&type=template&id=c09bb3be&"
import script from "./Archivar.vue?vue&type=script&lang=js&"
export * from "./Archivar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports